"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M3 22q-.825 0-1.4125-.5875T1 20V9h2v11h17v2zm4-4q-.825 0-1.4125-.5875T5 16V5h5V3q0-.825.5875-1.4125T12 1h4q.825 0 1.4125.5875T18 3v2h5v11q0 .825-.5875 1.4125T21 18zm5-13h4V3h-4z"
}), 'Cases');